var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg24Com(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9099A3",
    fillRule: "evenodd",
    d: "M.657 19.314v-.778c0-4.256 3.066-6.087 6.223-7.688l.396-.204c2.575-1.325 4.73-2.433 4.73-4.785 0-2.242-1.648-3.752-4.485-3.752C4.318 2.06 2.853 4.12 2.258 6.226c0 .137-1.555.091-1.555-1.19 0-.778.549-2.06 1.601-3.066C3.448.87 5.233.002 7.613.002c4.21 0 6.635 2.334 6.635 5.812s-2.7 4.896-5.812 6.452c-2.837 1.373-5.308 2.746-5.491 5.63l-.046.64h6.453c.778 0 1.144.366 1.144.96v.184c0 .64-.366.96-1.144.96H2.167c-1.053 0-1.51-.365-1.51-1.326zm21.737-.64h-8.191l8.191-10.663v10.663zm2.197-11.12c0-1.053-.458-1.556-1.785-1.556-1.144 0-1.419.274-2.06 1.144L12.83 17.347c-.458.64-.732 1.098-.732 1.647v.55c0 .64.549 1.143 1.51 1.143h8.695v4.806c0 .64.366 1.098.96 1.098h.275c.687 0 1.007-.366 1.007-1.098V7.553h.046zm3.02 13.543c.778 0 1.419-.64 1.419-1.418 0-.778-.595-1.419-1.373-1.419s-1.419.64-1.419 1.419c0 .778.595 1.419 1.373 1.419z",
    clipRule: "evenodd"
  })));
}

export default Svg24Com;